/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoBirthdaySimpleField {
    months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];

    restrict = "E";
    scope = {
      name: "@",
      ngModel: "=ngModel",
      contentKey: "@",
      disabled: "=ngDisabled",
      required: "=ngRequired"
    };

    require = "ngModel";

    templateUrl = "app/components/controls/birthdaySimpleTemplate.html";

    link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
      scope.resolvedMonthText = this.$translate.instant("LABEL_MONTH");
      scope.resolvedDayText = this.$translate.instant("LABEL_DAY");

      scope.days = this.days;
      scope.months = this.months;

      ngModel.$render = function () {
        scope.date = {
          selectedMonth: ngModel.$viewValue !== undefined && ngModel.$viewValue.length == 4 ? ngModel.$viewValue.substring(0,2) : '',
          selectedDay: ngModel.$viewValue !== undefined && ngModel.$viewValue.length == 4 ? ngModel.$viewValue.substring(2, 2) : '',
        };
      };

      scope.$watch('date', function (date) {
        if (scope.required) {
          let isMonthValid = date.selectedMonth != undefined && date.selectedMonth.length === 2;
          let isDayValid = date.selectedDay != undefined && date.selectedDay.length === 2;
          let isValid = isMonthValid && isDayValid;

          ngModel.$setValidity("required", isValid);

          if (isValid) {
            ngModel.$setViewValue(date.selectedMonth + date.selectedDay);
          }
        }
      }, true);
    }

    constructor(private $translate: angular.translate.ITranslateService) {

    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($translate) => {
        return new MeevoBirthdaySimpleField($translate);
      };

      directive.$inject = ["$translate"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoBirthdaySimpleField", MeevoBirthdaySimpleField.factory());

}